// ** Reducers Imports
import chat from "./chat";
import layout from "./layout";
import modal from "./modal";
import navbar from "./navbar";
import user from "./user";
import vendor from "./vendor";

const rootReducer = {
  navbar,
  layout,
  chat,
  modal,
  vendor,
  user,
};

export default rootReducer;
